const initialState = {
  pending: false,
  message: null,
};

const PDFViewer = (state = initialState, action) => {
  switch (action.type) {
    case 'PDF_UPLOAD_START':
      return {
        ...state,
        message: false,
        pending: true,
      };

    case 'PDF_UPLOAD_FAILURE':
      return {
        ...state,
        message: action.message || null,
        pending: false,
      };

    case 'PDF_UPLOAD_SUCCESS':
      return {
        ...state,
        pending: false,
      };

    default:
      return state;
  }
};

export default PDFViewer;
